import {
  clearRouterData,
  setFirstNameError,
  setLastNameError,
  setFirstNameNepError,
  setLastNameNepError,
  setDobError,
  setGenderError,
  setNationalityError,
  setIsNrnError,
  setNrnIdError,
  setNrnAddressError,
  setIssuedDateError,
  setIssuedDistrictError,
  setCitizenshipNoError,
  setPassportNoError,
  setExpiryDateError,
  setPanError,
  clearPersonalDetailError,
} from "../../redux/personSlice";


import {
  setCountryError,
  setPerCountryError,
  setStateError,
  setPerStateError,
  setDistrictError,
  setPerDistrictError,
  setMunicipalityError,
  setPerMunicipalityError,
  setWardError,
  setPerWardError,
  setToleError,
  setPerToleError,
  setEmailIdError,
  setMobileNoError,
  setTelephoneNoError,
  setPerTelephoneNoError,
  clearAddressError,
  setError,
  setBlockNoError,
  setFaxError,
  setPerBlockNoError,
} from "../../redux/addressSlice";
import {
  setOccupationTypeError,
  setBusinessTypeError,
  setOrganizationNameError,
  setAddressError,
  setDesignationError,
  setDocIdError,
  setFinancialDetailsError,
  clearOccupationDetailsError,
  setOccupationTypeOthersError,
  setBusinessTypeOthersError,
  setCompanyNameRelationError,
  setCompanyNameOrRelationError,
} from "../../redux/occupationSlice";
import {
  setGFirstNameError,
  setGLastNameError,
  setGRelationshipError,
  setGCountryError,
  setGStateError,
  setGDistrictError,
  setGMunicipalityError,
  setGWardError,
  setGToleError,
  setGMobileNoError,
  setGEmailIdError,
  setGFaxError,
  setGTelephoneNoError,
  clearGuardianDetailsError,
  setGDocIdError,
  setGIssuedDateError,
  setGIssuedDateBsError,
  setGIssuedFromError,
  setGFileIdError,
  setGBackFileIdError,
} from "../../redux/guardianSlice";
import { setFamilyDetailsError } from "../../redux/familySlice";
import {
  setBankDetailsError,
  setTypesOfBankAccountError,
  setBankError,
  setBankAccountNumberError,
  clearBankDetailsError,
} from "../../redux/bankSlice";
import { setBoidDetailsError } from "../../redux/boidSlice";
import {
  setDocumentDetailsError,
  setDocumentError,
  setDocumentValue,
} from "../../redux/documentSlice";
import ViewCompanyData from "./viewCompanyData";
import {
  setCompanyNameError,
  setCompanyTypeError,
  setRegistrationDateError,
  setIncorporationDateError,
  setCountryOfRegistrationError,
  setRegistrationNoError,
  setRegistrationOfficeError,
  setTypesOfBusinessOfCompanyError,
  setAreaOfWorkError,
  setNameAddressOfCompanyError,
  setIsListedError,
  setListingDateError,
  setPanVatRegistrationNoError,
  setIsSubsidiaryError,
  clearCompanyErrorMsg,
  setHasPanError,
  setRegDistrictError,
  setPanEximptionError,
} from "../../redux/companySlice";
import {
  setTypeError,
  setDirFirstNameError,
  setDirLastNameError,
  setFatherFirstNameError,
  setFatherLastNameError,
  setGrandFatherFirstNameError,
  setGrandFatherLastNameError,
  setDirDesignationError,
  setPanNoError,
  setSpouseFirstNameError,
  setSpouseLastNameError,
  setDirCountryError,
  setDirStateError,
  setDirDistrictError,
  setDirMunicipalityError,
  setDirWardError,
  setDirToleError,
  setDirBlockNoError,
  setDirTelephoneNoError,
  setDirEmailIdError,
  setDirMobileNoError,
  setDirPerCountryError,
  setDirPerStateError,
  setDirPerDistrictError,
  setDirPerMunicipalityError,
  setDirPerWardError,
  setDirPerToleError,
  setDirPerBlockNoError,
  setDirPerTelephoneNoError,
  setTelephoneNo,
  clearDirectorDetailsError,
  setDirError,
} from "../../redux/directorSlice";
import { filterCompanyDocument, filterDocument } from "./documentDetails";
import {
  setDynamicSelectedError,
  setDynamicSelectedValue,
} from "../../redux/dynamicFieldSlice";
import { setErrorList } from "../../redux/lookupSlice";
import { setActive, setActivBySectionCode } from "../../redux/routerSlice";
import { useDispatch, useSelector } from "react-redux";
import { clearMoneyLaunderingDetailsError, setBeneficiaryNameError, setBeneficiaryRelationError, setFelonyError, setMoneyLaunderingDetailsError, setRelatedHighRankingOfficialNameError, setRelatedHighRankingOfficialRelationError } from "../../redux/moneyLaunderingPreventionSlice";
import { alphabetCheck, alphanumericCheck, bankAccountNoValidation, checkAlphabetsAndDotsOnly, checkAlphanumeric, checkNepaliAlphabetsAndDotsOnly, emailCheck, numberCheck, numberCheckTel, toleCheck } from "../../helper/validationHelper";

let redirectList = [];

const showErrMsg = (toast, dispatch, msg, sectionCd, setctionList) => {
  console.log("showErrMsg", msg);
  const section = setctionList.find((section) => section.code === sectionCd);
  if (section) {
    redirectList.push({ section, msg });
  }
  toast.error("Error Message", msg);
};


const companyDetailsValidationForSave = (
  data,
  dispatch,
  toast,
  sectionList
) => {
  dispatch(clearCompanyErrorMsg());
  const comapnyDeteails = data.companyDetails;
  let hasError = false;
  if (
    !comapnyDeteails.companyName
  ) {
    hasError = true;
    dispatch(
      setCompanyNameError({
        message: "Company Name is required",
        section: "CD",
      })
    );
    showErrMsg(toast, dispatch, "Company Name is required", "CD", sectionList);
  }
  if (
    !comapnyDeteails.companyType
  ) {
    hasError = true;
    dispatch(
      setCompanyTypeError({
        message: "Company Type is required",
        section: "CD",
      })
    );
    showErrMsg(toast, dispatch, "Company Type is required", "CD", sectionList);
  }
  if (
    !comapnyDeteails.incorporationDate
  ) {
    hasError = true;
    dispatch(
      setIncorporationDateError({
        message: "Incorporation Date is required",
        section: "CD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Incorporation Date is required",
      "CD",
      sectionList
    );
  }
  if (
    !comapnyDeteails.countryOfRegistration
  ) {
    hasError = true;
    dispatch(
      setCountryOfRegistrationError({
        message: "Country is required",
        section: "CD",
      })
    );
    showErrMsg(toast, dispatch, "Country is required", "CD", sectionList);
  }
  if (
    !comapnyDeteails.registrationNo
  ) {
    hasError = true;
    dispatch(
      setRegistrationNoError({
        message: "Registration No is required",
        section: "CD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Registration No is required",
      "CD",
      sectionList
    );
  }
  if (
    !comapnyDeteails.registrationDate
  ) {
    hasError = true;
    dispatch(
      setRegistrationDateError({
        message: "Registration Date is required",
        section: "CD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Registration Date is required",
      "CD",
      sectionList
    );
  }
  if (hasError) {
    toast.error("Error Message", "Required field are missing")
  }
  return !hasError;
};

const companyDetailsValidation = (data, dispatch, toast, sectionList) => {
  dispatch(clearCompanyErrorMsg());
  const comapnyDeteails = data.companyDetails;
  let hasError = false;
  if (
    comapnyDeteails.companyName === null ||
    comapnyDeteails.companyName === ""
  ) {
    hasError = true;
    dispatch(
      setCompanyNameError({
        message: "Company Name is required",
        section: "CD",
      })
    );
    showErrMsg(toast, dispatch, "Company Name is required", "CD", sectionList);
  }
  if (
    comapnyDeteails.companyType === null ||
    comapnyDeteails.companyType === ""
  ) {
    hasError = true;
    dispatch(
      setCompanyTypeError({
        message: "Company Type is required",
        section: "CD",
      })
    );
    showErrMsg(toast, dispatch, "Company Type is required", "CD", sectionList);
  }

  if (
    comapnyDeteails.incorporationDate === null ||
    comapnyDeteails.incorporationDate === ""
  ) {
    hasError = true;
    dispatch(
      setIncorporationDateError({
        message: "Incorporation Date is required",
        section: "CD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Incorporation Date is required",
      "CD",
      sectionList
    );
  }
  if (
    comapnyDeteails.countryOfRegistration === null ||
    comapnyDeteails.countryOfRegistration === ""
  ) {
    hasError = true;
    dispatch(
      setCountryOfRegistrationError({
        message: "Country is required",
        section: "CD",
      })
    );
    showErrMsg(toast, dispatch, "Country is required", "CD", sectionList);
  }
  if (
    comapnyDeteails.registrationOffice === null ||
    comapnyDeteails.registrationOffice === ""
  ) {
    console.log("inside")
    hasError = true;
    dispatch(setRegistrationOfficeError({
      message: "Registration Office is required",
      section: "CD"
    }));
    showErrMsg(
      toast,
      dispatch,
      "Registration Office is required",
      "CD",
      sectionList
    );
  }

  if (
    comapnyDeteails.regDistrict === null ||
    comapnyDeteails.regDistrict === ""
  ) {
    hasError = true;
    dispatch(setRegDistrictError({
      message: "Registration District is required",
      section: "CD"
    }));
    showErrMsg(
      toast,
      dispatch,
      "Registration District is required",
      "CD",
      sectionList
    );
  }
  if (
    comapnyDeteails.registrationNo === null ||
    comapnyDeteails.registrationNo === ""
  ) {
    hasError = true;
    dispatch(setRegistrationNoError(
      {
        message: "Registration Number is required",
        section: "CD"
      }));
    showErrMsg(
      toast,
      dispatch,
      "Registration Number is required",
      "CD",
      sectionList
    );
  }



  if (
    comapnyDeteails.registrationDate === null ||
    comapnyDeteails.registrationDate === ""
  ) {
    hasError = true;
    dispatch(setRegistrationDateError(
      {
        message: "Registration Date is required",
        section: "CD"
      }));
    showErrMsg(
      toast,
      dispatch,
      "Registration Date is required",
      "CD",
      sectionList
    );
  }

  if (comapnyDeteails.hasPan === null || comapnyDeteails.hasPan === "") {
    hasError = true;
    dispatch(setHasPanError(
      {
        message: "Has Pan Exempted is required",
        section: "CD"
      }));
    showErrMsg(
      toast,
      dispatch,
      "Has Pan Exempted is required",
      "CD",
      sectionList
    );
  }

  if (!comapnyDeteails.hasPan) {
    if (
      comapnyDeteails.panEximption === null ||
      comapnyDeteails.panEximption === ""
    ) {
      hasError = true;
      dispatch(
        setPanEximptionError({
          message: "Pan Eximption Reason is required",
          section: "CD",
        })
      );

      showErrMsg(
        toast,
        dispatch,
        "Pan Eximption Reason is required",
        "CD",
        sectionList
      );
    }
  } else {
    if (
      comapnyDeteails.panVatRegistrationNo === null ||
      comapnyDeteails.panVatRegistrationNo === ""
    ) {
      hasError = true;
      dispatch(
        setPanVatRegistrationNoError({
          message: "Pan Vat Registration Number is required",
          section: "CD",
        })
      );

      showErrMsg(
        toast,
        dispatch,
        "Pan Vat Registration Number is required",
        "CD",
        sectionList
      );
    }
  }

  if (
    comapnyDeteails.panVatRegistrationNo &&
    !numberCheck(comapnyDeteails.panVatRegistrationNo)
  ) {
    hasError = true;
    dispatch(
      setPanVatRegistrationNoError({
        message: "Numbers only supported",
        section: "CD",
      })
    );
    showErrMsg(toast, dispatch, "Numbers only supported", "CD", sectionList);
  }
  if (
    comapnyDeteails.isSubsidiary === null ||
    comapnyDeteails.isSubsidiary === ""
  ) {
    hasError = true;
    dispatch(
      setIsSubsidiaryError({
        message: "Is Subsidiary is required",
        section: "CD",
      })
    );
    showErrMsg(toast, dispatch, "Is Subsidiary is required", "CD", sectionList);
  }
  if (comapnyDeteails.isSubsidiary) {
    if (
      comapnyDeteails.typesOfBusinessOfCompany === null ||
      comapnyDeteails.typesOfBusinessOfCompany === ""
    ) {
      hasError = true;
      dispatch(
        setTypesOfBusinessOfCompanyError({
          message: "Type of Bussiness is required",
          section: "CD",
        })
      );
      showErrMsg(
        toast,
        dispatch,
        "Type of Bussiness is required",
        "CD",
        sectionList
      );
    }

    if (
      comapnyDeteails.areaOfWork === null ||
      comapnyDeteails.areaOfWork === ""
    ) {
      hasError = true;
      dispatch(
        setAreaOfWorkError({
          message: "Area Of Work is required",
          section: "CD",
        })
      );
      showErrMsg(
        toast,
        dispatch,
        "Area Of Work is required",
        "CD",
        sectionList
      );
    }
    if (
      comapnyDeteails.nameAddressOfCompany === null ||
      comapnyDeteails.nameAddressOfCompany === ""
    ) {
      hasError = true;
      dispatch(
        setNameAddressOfCompanyError({
          message: "Name of company is required",
          section: "CD",
        })
      );
      showErrMsg(
        toast,
        dispatch,
        "Name of company is required",
        "CD",
        sectionList
      );
    }
    if (comapnyDeteails.isListed === null || comapnyDeteails.isListed === "") {
      hasError = true;
      dispatch(
        setIsListedError({
          message: "Is Listed is required",
          section: "CD",
        })
      );

      showErrMsg(toast, dispatch, "Is Listed is required", "CD", sectionList);
    }
    if (comapnyDeteails.isListed) {
      if (
        comapnyDeteails.listingDate === null ||
        comapnyDeteails.listingDate === ""
      ) {
        hasError = true;
        dispatch(
          setListingDateError({
            message: "Listing Dateis required",
            section: "CD",
          })
        );
        showErrMsg(
          toast,
          dispatch,
          "Listing Date is required",
          "CD",
          sectionList
        );
      }
    }
    if (hasError) {
      toast.error("Error Message", "Required field are missing");
    }
  }

  return !hasError;
};

const companyAddressValidation = (data, dispatch, toast, sectionList) => {
  dispatch(clearAddressError());
  let hasError = false;
  const {
    country,
    state,
    district,
    municipality,
    ward,
    tole,
    emailId,
    mobileNo,
    telephoneNo,
    locationType,
    LatLng,
  } = data.addressDetails;
  if (country === "" || country == null) {
    hasError = true;
    dispatch(
      setCountryError({
        message: "Country is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Country is required", "AD", sectionList);
  }

  if (country == "NP") {
    if (state === "" || state == null) {
      hasError = true;
      dispatch(
        setStateError({
          message: "State is required",
          section: "AD",
        })
      );
      showErrMsg(toast, dispatch, "State is required", "AD", sectionList);
    }

    if (district === "" || district == null) {
      hasError = true;
      dispatch(
        setDistrictError({
          message: "District is required",
          section: "AD",
        })
      );
      showErrMsg(toast, dispatch, "District is required", "AD", sectionList);
    }

    if (municipality === "" || municipality == null) {
      hasError = true;
      dispatch(
        setMunicipalityError({
          message: "Municipality is required",
          section: "AD",
        })
      );
      showErrMsg(toast, dispatch, "Municipality is required", "AD", sectionList);
    }

    if (ward === "" || ward == null) {
      hasError = true;
      dispatch(
        setWardError({
          message: "Ward is required",
          section: "AD",
        })
      );
      showErrMsg(toast, dispatch, "Ward is required", "AD", sectionList);
    }
  }
  if (tole === "" || tole == null) {
    hasError = true;
    dispatch(
      setToleError({
        message: "Tole is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Tole is required", "AD", sectionList);
  }



  if (mobileNo === "" || mobileNo == null) {
    hasError = true;
    dispatch(
      setMobileNoError({
        message: "Mobile Number is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Mobile Number is required", "AD", sectionList);
  } else if (country === "NP" && mobileNo.length !== 13) {
    hasError = true;
    dispatch(
      setMobileNoError({
        message: "Mobile Number must contain 10 digits",
        section: "AD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Mobile number must contain 10 digits",
      "AD",
      sectionList
    );
  } else if (mobileNo.length < 5) {
    hasError = true;
    dispatch(
      setMobileNoError({
        message: "Mobile Number length must be greater than 5 digits",
        section: "AD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Mobile Number length must be greater than 5 digits",
      "AD",
      sectionList
    );
  }

  if (emailId === "" || emailId == null) {
    hasError = true;
    dispatch(
      setEmailIdError({
        message: "Email Id is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Email Id is required", "AD", sectionList);
  }
  if (emailId && !emailCheck(emailId)) {
    hasError = true;
    dispatch(
      setEmailIdError({
        message: "Provide Valid Email",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Provide Valid Email", "AD", sectionList);
  }

  const documentList = data.documentDetails.documentList;

  if (
    !locationType ||
    (locationType === "G" &&
      (!LatLng ||
        !LatLng.mapPosition ||
        !LatLng.mapPosition.lat ||
        !LatLng.mapPosition.lng)) ||
    (locationType === "I" &&
      !documentList.find((d) => d.documentTypeId === "MP" && d.fileId))
  ) {
    hasError = true;
    dispatch(setError({ message: "Location is reqired", section: "AD" }));
    // dispatch(setError({ key: "locationError", value: "Location is reqired" }));
    showErrMsg(toast, dispatch, "Location is reqired", "AD", sectionList);
  }

  if (hasError) {
    toast.error("Error Message", "Required field are missing");

  }
  return !hasError;
};

const companyDirectorValidation = (data, dispatch, toast, sectionList) => {
  // dispatch(clearDirectorDetailsError());
  const directorDetails = data.directorDetails.directorDetailsList;
  if (!directorDetails.length) {
    dispatch(
      setDirError({
        message: "Director and Contact Person of company are required",
        section: "DD",
      })
    );
    toast.error("Error Message", "Director and Contact Person of company are required");

    return false;
  }

  if (directorDetails && directorDetails.length) {
    const contactPerson = directorDetails.find((d) => d.isContactPerson);
    const director = directorDetails.find(d => d.isDirector);
    if (!contactPerson) {
      dispatch(
        setDirError({
          message: "At least one Contact Person is required",
          section: "DD",
        })
      );
      toast.error("Error Message", "At least one Contact Person is required");
      return false;
    }

    if (!director) {
      dispatch(
        setDirError({
          message: "At least one Director is required",
          section: "DD",
        })
      );
      toast.error("Error Message", "At least one Director is required");
      return false;
    }
  }

  const aDirector = directorDetails.find((d) => d.authorizedPerson);
  if (!aDirector) {
    dispatch(
      setDirError({
        message: "Authorized Person is required",
        section: "DD",
      })
    );
    toast.error("Error Message", "Authorized Person is required");

    return false;
  } else if (!aDirector.mobileNo || !aDirector.emailId) {
    dispatch(
      setDirError({
        message: "Authorized Person Phone and Email are required",
        section: "DD",
      })
    );
    toast.error("Error Message", "Authorized Person Phone and Email are required");
    return false;
  } else if (
    aDirector.documentList.filter(
      (d) =>
        (d.documentTypeId === "PH" || d.documentTypeId === "DCZ") && !d.fileId
    ).length
  ) {
    dispatch(
      setDirError({
        message: "Authorized Person Citizenship and Photo are required",
        section: "DD",
      })
    );
    toast.error("Error Message", "Authorized Person Citizenship and Photo are required");
    return false;
  }
  return true;
};

const companyDirectorValidationForSave = (
  data,
  dispatch,
  toast,
  sectionList
) => {
  dispatch(clearDirectorDetailsError());
  const directorDetails = data.directorDetails.directorDetailsList;
  if (directorDetails.length !== 0) {
    let hasError = false;
    for (let i in directorDetails) {
      if (
        directorDetails[i].firstName === "" ||
        directorDetails[i].firstName === null ||
        directorDetails[i].firstName === undefined
      ) {
        hasError = true;
        dispatch(
          setDirFirstNameError({
            message: "Name is required",
            section: "DD",
          })
        );
        showErrMsg(toast, dispatch, "Name is required", "DD", sectionList);
      }

      if (
        directorDetails[i].lastName === "" ||
        directorDetails[i].lastName === null ||
        directorDetails[i].lastName === undefined
      ) {
        hasError = true;
        dispatch(
          setDirLastNameError({
            message: "Name is required",
            section: "DD",
          })
        );
        showErrMsg(toast, dispatch, "Name is required", "DD", sectionList);
      }

      if (
        directorDetails[i].fatherFirstName === "" ||
        directorDetails[i].fatherFirstName === null ||
        directorDetails[i].fatherFirstName === undefined
      ) {
        hasError = true;
        dispatch(
          setFatherFirstNameError({
            message: "Father Name is required",
            section: "DD",
          })
        );
        showErrMsg(
          toast,
          dispatch,
          "Father Name is required",
          "DD",
          sectionList
        );
      }

      if (
        directorDetails[i].fatherLastName === "" ||
        directorDetails[i].fatherLastName === null ||
        directorDetails[i].fatherLastName === undefined
      ) {
        hasError = true;
        dispatch(
          setFatherLastNameError({
            message: "Father Name is required",
            section: "DD",
          })
        );
        showErrMsg(
          toast,
          dispatch,
          "Father Name is required",
          "DD",
          sectionList
        );
      }

      if (
        directorDetails[i].grandFatherFirstName === "" ||
        directorDetails[i].grandFatherFirstName === null ||
        directorDetails[i].grandFatherFirstName === undefined
      ) {
        hasError = true;
        dispatch(
          setGrandFatherFirstNameError({
            message: "Grand Father Name is required",
            section: "DD",
          })
        );

        showErrMsg(
          toast,
          dispatch,
          "Grand Father Name is required",
          "DD",
          sectionList
        );
      }

      if (
        directorDetails[i].grandFatherLastName === "" ||
        directorDetails[i].grandFatherLastName === null ||
        directorDetails[i].grandFatherLastName === undefined
      ) {
        hasError = true;
        dispatch(
          setGrandFatherLastNameError({
            message: "Grand Father Name is required",
            section: "DD",
          })
        );
        showErrMsg(
          toast,
          dispatch,
          "Grand Father Name is required",
          "DD",
          sectionList
        );
      }

      if (
        directorDetails[i].emailId === "" ||
        directorDetails[i].emailId == null
      ) {
        hasError = true;
        dispatch(
          setDirEmailIdError({
            message: "Email Id is required",
            section: "DD",
          })
        );
        showErrMsg(toast, dispatch, "Email Id is required", "DD", sectionList);
      }

      if (!emailCheck(directorDetails[i].emailId)) {
        hasError = true;
        dispatch(
          setDirEmailIdError({
            message: "Provide Valid Email",
            section: "DD",
          })
        );
        showErrMsg(toast, dispatch, "Provide Valid Email", "DD", sectionList);
      }

      if (
        directorDetails[i].mobileNo === "" ||
        directorDetails[i].mobileNo == null
      ) {
        hasError = true;
        dispatch(
          setDirMobileNoError({
            message: "Mobile Number is required",
            section: "DD",
          })
        );
        showErrMsg(
          toast,
          dispatch,
          "Mobile Number is required",
          "DD",
          sectionList
        );
      }

      if (
        directorDetails[i].mobileNo &&
        !numberCheck(directorDetails[i].mobileNo) &&
        directorDetails[i].mobileNo.length !== 10
      ) {
        hasError = true;
        dispatch(
          setPanNoError({
            message: "9 digit numbers only supported",
            section: "DD",
          })
        );
        showErrMsg(
          toast,
          dispatch,
          "9 digit numbers only supported",
          "DD",
          sectionList
        );
      }

      // if (
      //   directorDetails[i].telephoneNo &&
      //   !numberCheck(directorDetails[i].telephoneNo)
      // ) {
      //   hasError = true;
      //   dispatch(setDirTelephoneNoError("Number only supported"));
      //   showErrMsg(toast, dispatch, "Number only supported", "DD", sectionList);
      // }
      if (hasError) {
        toast.error("Error Message", "Required field are missing")

      }
      return !hasError;
    }
  } else {
    toast.error("Error Message", "Director List is empty")
    return false;
  }
};

// const bankValidation = (data, dispatch, toast, sectionList) => {
//   dispatch(clearBankDetailsError());
//   let hasError = false;
//   const bankDetails = data.bankDetails.bankDetailsList;
//   if (bankDetails.length !== 0) {
//     for (let i in bankDetails) {
//       if (
//         bankDetails[i].typesOfBankAccount === "" ||
//         bankDetails[i].typesOfBankAccount == null
//       ) {
//         hasError = true;
//         dispatch(
//           setTypesOfBankAccountError({
//             message: "Bank Account Type is required",
//             section: "BKD",
//           })
//         );
//         showErrMsg(
//           toast,
//           dispatch,
//           "Bank Account Type is required",
//           "BKD",
//           sectionList
//         );
//       }
//       if (bankDetails[i].bank === "" || bankDetails[i].bank == null) {
//         hasError = true;
//         dispatch(
//           setBankError({
//             message: "Bank is required",
//             section: "BKD",
//           })
//         );
//         showErrMsg(toast, dispatch, "Bank is required", "BKD", sectionList);
//       }
//       if (
//         bankDetails[i].bankAccountNumber === "" ||
//         bankDetails[i].bankAccountNumber == null
//       ) {
//         hasError = true;
//         dispatch(
//           setBankAccountNumberError({
//             message: "Bank Account Number is required",
//             section: "BKD",
//           })
//         );
//         showErrMsg(
//           toast,
//           dispatch,
//           "Bank Account Number is required",
//           "BKD",
//           sectionList
//         );
//       }
//       if (hasError) {
//         toast.error("Error Message", "Required field are missing");
//       }

//       return !hasError;
//     }
//   } else {
//     toast.error("Error Message", "Bank Detail List is empty")
//     dispatch(
//       setBankDetailsError({
//         message: "Bank Detail is required",
//         section: "BKD",
//       })
//     );
//     return false;
//   }
// };

// const bankValidation = (data, dispatch, toast, sectionList) => {
//   dispatch(clearBankDetailsError());
//   let hasError = false;

//   const bankDetails = data.bankDetails.bankDetailsList
//   // console.log("Bank Details:", bankDetails);

//   // Check for the presence of at least one primary account
//   if (!bankDetails.find(bb => bb.isPrimaryAccount)) {
//     hasError = true;
//     dispatch(
//       setTypesOfBankAccountError({
//         message: "Primary Bank Account is required",
//         section: "BKD",
//       })
//     );
//     showErrMsg(toast, dispatch, "Primary Bank Account is required", "BKD", sectionList);
//   }

//   //  Check if the account number is empty or fails the alphanumeric validation
//   // Validate each bank detail's account number
//   bankDetails.forEach((bankDetail, index) => {
//     const accountNo = bankDetail.bankAccountNumber;
//     // console.log(`Validating account number at row ${index + 1}:`, accountNo);

//     // Check if the account number is empty or fails the alphanumeric validation
//     if (!accountNo || !bankAccountNoValidation(accountNo)) {
//       hasError = true;
//       const errorMessage = `Invalid account number at row ${index + 1} (Bank Account Number must be alphanumeric and cannot be empty.)`;
//       dispatch(
//         setBankAccountNumberError({
//           message: errorMessage,
//           section: "BKD",
//         })
//       );
//       showErrMsg(
//         toast,
//         dispatch,
//         errorMessage,
//         "BKD",
//         sectionList
//       );
//     }
//   });

//   if (hasError) {
//     toast.error("Error Message", "Required fields are missing");
//   }

//   return !hasError;
// };

const bankValidation = (data, dispatch, toast, sectionList) => {
  dispatch(clearBankDetailsError());
  let hasError = false;
  const bankDetails = data.bankDetails.bankDetailsList
  // console.log("Bank Details:", bankDetails);
  // Check for the presence of at least one primary account
  if (!bankDetails.find(bb => bb.isPrimaryAccount)) {
    hasError = true;
    dispatch(
      setTypesOfBankAccountError({
        message: "Primary Bank Account is required",
        section: "BKD",
      })
    );
    showErrMsg(toast, dispatch, "Primary Bank Account is required", "BKD", sectionList);
  }
  //  Check if the account number is empty or fails the alphanumeric validation
  // Validate each bank detail's account number
  bankDetails.forEach((bankDetail, index) => {
    const accountNo = bankDetail.bankAccountNumber;
    // console.log(`Validating account number at row ${index + 1}:`, accountNo);

    // Check if the account number is empty or fails the alphanumeric validation
    if (!accountNo || !bankAccountNoValidation(accountNo)) {
      hasError = true;
      const errorMessage = `Invalid account number at row ${index + 1} (Bank Account Number must be alphanumeric and cannot be empty.)`;
      dispatch(
        setBankAccountNumberError({
          message: errorMessage,
          section: "BKD",
        })
      );
      showErrMsg(
        toast,
        dispatch,
        errorMessage,
        "BKD",
        sectionList
      );
    }
  });

  if (hasError) {
    toast.error("Error Message", "Required fields are missing");
  }

  return !hasError;
};

const boidValidation = (data, dispatch, toast, sectionList) => {
  const boidDetails = data.boidDetails.boidList;
  if (
    (data.boidDetails.hasBoid && boidDetails.length === 0) ||
    (!data.boidDetails.hasBoid &&
      (data.boidDetails.fdpId == null || data.boidDetails.createBoid == null))
  ) {
    dispatch(
      setBoidDetailsError({
        message: "BOID details required",
        section: "BD",
      })
    );
    //  dispatch(setBoidDetailsError("BOID details required"));
    // showErrMsg(toast, dispatch, "BOID details required", "BD", sectionList);
    return false;
  } else if ((data.boidDetails.hasBoid && boidDetails.length && !boidDetails.find(b => b.isForwarded))) {
    dispatch(
      setBoidDetailsError({
        message: "Atleast one BOID must be fowarded",
        section: "BD",
      })
    );
  }
  dispatch(setBoidDetailsError({}));

  return true;
};

const personAddressValidation = (data, dispatch, toast, sectionList) => {
  dispatch(clearAddressError());
  let hasError = false;
  const {
    country,
    state,
    district,
    municipality,
    ward,
    tole,
    fax,
    blockNo,
    telephoneNo,
    emailId,
    mobileNo,
    perCountry,
    perState,
    perDistrict,
    perMunicipality,
    perWard,
    perTole,
    locationType,
    perBlockNo,
    perTelephoneNo,
    LatLng,
  } = data.addressDetails;
  const addressDetails = data.addressDetails;

  if (country === "" || country == null) {
    hasError = true;
    dispatch(
      setCountryError({
        message: "Country is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Country is required", "AD", sectionList);
  }
  if (country === "NP") {
    if (state === "" || state == null) {
      hasError = true;
      dispatch(
        setStateError({
          message: "State is required",
          section: "AD",
        })
      );
      showErrMsg(toast, dispatch, "State is required", "AD", sectionList);
    }

    if (district === "" || district == null) {
      hasError = true;
      dispatch(
        setDistrictError({
          message: "District is required",
          section: "AD",
        })
      );
      showErrMsg(toast, dispatch, "District is required", "AD", sectionList);
    }

    if (municipality === "" || municipality == null) {
      hasError = true;
      dispatch(
        setMunicipalityError({
          message: "Municipality is required",
          section: "AD",
        })
      );
      showErrMsg(toast, dispatch, "Municipality is required", "AD", sectionList);
    }

    if (ward === "" || ward == null) {
      hasError = true;
      dispatch(
        setWardError({
          message: "Ward is required",
          section: "AD",
        })
      );
      showErrMsg(toast, dispatch, "Ward is required", "AD", sectionList);
    }
  }
  // if (tole === "" || tole == null) {
  //   hasError = true;
  //   dispatch(
  //     setToleError({
  //       message: "Tole is required",
  //       section: "AD",
  //     })
  //   );
  //   showErrMsg(toast, dispatch, "Tole is required", "AD", sectionList);
  // }
  if (tole === "" || tole == null || !toleCheck(tole)) {
    hasError = true;
    dispatch(
      setToleError({
        message: "Tole is required or invalid input",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Tole is required", "AD", sectionList);
  }

  // BlockNo validation  
  if (addressDetails.blockNo) {
    // console.log("what", addressDetails);// Debugging
    checkAlphanumeric(
      addressDetails.blockNo,
      () => (hasError = true),
      dispatch,
      setBlockNoError,
      "AD",
      "BlockNo is required in alpha numeric characters only"
    );
  }


  if (mobileNo === "" || mobileNo == null || !numberCheck(mobileNo)) {
    hasError = true;
    dispatch(
      setMobileNoError({
        message: "Mobile Number is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Mobile Number is required", "AD", sectionList);
  } else if (country === "NP" && mobileNo.length !== 13) {
    hasError = true;
    dispatch(
      setMobileNoError({
        message: "Mobile Number must contain 10 digits",
        section: "AD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Mobile number must contain 10 digits",
      "AD",
      sectionList
    );
  } else if (mobileNo.length < 5) {
    hasError = true;
    dispatch(
      setMobileNoError({
        message: "Mobile Number length must be greater than 5 digits",
        section: "AD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Mobile Number length must be greater than 5 digits",
      "AD",
      sectionList
    );
  }

  // if (telephoneNo && !numberCheck(telephoneNo)) {
  //   hasError = true;
  //   dispatch(setTelephoneNoError("Number only supported"));
  //   showErrMsg(toast, dispatch, "Number only supported", "AD", sectionList);
  // }
  // if (mobileNo && !numberCheck(mobileNo) && mobileNo.length !== 10) {
  //   hasError = true;
  //   dispatch(setMobileNoError("10 digit numbers only supported"));
  //   showErrMsg(
  //     toast,
  //     dispatch,
  //     "10 digit numbers only supported",
  //     "AD",
  //     sectionList
  //   );
  // }

  if (telephoneNo && !numberCheckTel(telephoneNo)) {
    hasError = true;
    dispatch(
      setTelephoneNoError({
        message: "Valid telephone number is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Valid telephone number is required", "AD", sectionList);
  }

  if (fax && !numberCheckTel(fax)) {
    hasError = true;
    dispatch(
      setFaxError({
        message: "Valid fax number is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Valid fax number is required", "AD", sectionList);
  }

  if (emailId === "" || emailId == null || !emailCheck(emailId)) {
    hasError = true;
    dispatch(
      setEmailIdError({
        message: "Vaild Email Id is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Vaild Email Id is required", "AD", sectionList);
  }
  if (emailId && !emailCheck(emailId)) {
    hasError = true;
    dispatch(
      setEmailIdError({
        message: "Provide Valid Email",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Provide Valid Email", "AD", sectionList);
  }

  if (perCountry === "" || perCountry == null) {
    hasError = true;
    dispatch(
      setPerCountryError({
        message: "Country is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Country is required", "AD", sectionList);
  }
  if (perCountry === "NP") {
    if (perState === "" || perState == null) {
      hasError = true;
      dispatch(
        setPerStateError({
          message: "State is required",
          section: "AD",
        })
      );
      showErrMsg(toast, dispatch, "State is required", "AD", sectionList);
    }

    if (perDistrict === "" || perDistrict == null) {
      hasError = true;
      dispatch(
        setPerDistrictError({
          message: "District is required",
          section: "AD",
        })
      );
      showErrMsg(toast, dispatch, "District is required", "AD", sectionList);
    }

    if (perMunicipality === "" || perMunicipality == null) {
      hasError = true;
      dispatch(
        setPerMunicipalityError({
          message: "Municipality is required",
          section: "AD",
        })
      );
      showErrMsg(toast, dispatch, "Municipality is required", "AD", sectionList);
    }

    if (perWard === "" || perWard == null) {
      hasError = true;
      dispatch(
        setPerWardError({
          message: "Ward is required",
          section: "AD",
        })
      );
      showErrMsg(toast, dispatch, "Ward is required", "AD", sectionList);
    }
  }
  if (perTole === "" || perTole == null || !toleCheck(perTole)) {
    hasError = true;
    dispatch(
      setPerToleError({
        message: "Tole is required or invalid input",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Tole is required or invalid input", "AD", sectionList);
  }

  if (addressDetails.perBlockNo) {
    // console.log("what", addressDetails);// Debugging
    checkAlphanumeric(
      addressDetails.perBlockNo,
      () => (hasError = true),
      dispatch,
      setPerBlockNoError,
      "AD",
      "BlockNo is required in alpha numeric characters only"
    );
  }

  if (perTelephoneNo && !numberCheckTel(perTelephoneNo)) {
    hasError = true;
    dispatch(
      setPerTelephoneNoError({
        message: "Valid telephone number is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Valid telephone number is required", "AD", sectionList);
  }

  const documentList = data.documentDetails.documentList;

  if (
    !locationType ||
    (locationType === "G" &&
      (!LatLng ||
        !LatLng.mapPosition ||
        !LatLng.mapPosition.lat ||
        !LatLng.mapPosition.lng)) ||
    (locationType === "I" &&
      !documentList.find((d) => d.documentTypeId === "MP" && d.fileId))
  ) {
    hasError = true;
    dispatch(setError({ message: "Location is reqired", section: "AD" }));
    // dispatch(setError({ key: "locationError", value: "Location is reqired" }));
    showErrMsg(toast, dispatch, "Location is reqired", "AD", sectionList);
  }

  // if (perTelephoneNo && !numberCheck(perTelephoneNo)) {
  //   hasError = true;
  //   dispatch(setPerTelephoneNoError("Number only supported"));
  //   showErrMsg(toast, dispatch, "Number is required", "AD", sectionList);
  // }
  if (hasError) {
    toast.error("Error Message", "Required field are missing");
  }
  return !hasError;
};

const personAddressValidationForSave = (data, dispatch, toast, sectionList) => {
  dispatch(clearAddressError());
  let hasError = false;
  const {
    country,
    state,
    district,
    municipality,
    ward,
    tole,
    blockNo,
    telephoneNo,
    emailId,
    mobileNo,
    perCountry,
    perState,
    perDistrict,
    perMunicipality,
    perWard,
    perTole,
    perBlockNo,
    perTelephoneNo,
  } = data.addressDetails;

  if (mobileNo === "" || mobileNo == null) {
    hasError = true;
    dispatch(
      setMobileNoError({
        message: "Mobile Number is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Mobile Number is required", "AD", sectionList);
  }

  // if (telephoneNo && !numberCheck(telephoneNo)) {
  //   hasError = true;
  //   dispatch(setTelephoneNoError("Number only supported"));
  //   showErrMsg(toast, dispatch, "Number only suppoerted", "AD", sectionList);
  // }
  if (mobileNo && !numberCheck(mobileNo) && mobileNo.length !== 10) {
    hasError = true;
    dispatch(
      setMobileNoError({
        message: "10 digit numbers only supported",
        section: "AD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "10 digit numbers only supported",
      "AD",
      sectionList
    );
  }

  if (emailId === "" || emailId == null) {
    hasError = true;
    dispatch(
      setEmailIdError({
        message: "Email Id is required",
        section: "AD",
      })
    );
    showErrMsg(toast, dispatch, "Email Id is required", "AD", sectionList);
  }

  if (emailId && !emailCheck(emailId)) {
    hasError = true;
    dispatch(
      setEmailIdError({
        message: "Provide Valid Email",
        section: "AD",
      })
    );
    // dispatch(setEmailIdError("Provide Valid Email"));
    showErrMsg(toast, dispatch, "Provide Valid Email", "AD", sectionList);
  }

  // if (perTelephoneNo && !numberCheck(perTelephoneNo)) {
  //   hasError = true;
  //   dispatch(setPerTelephoneNoError("Number only supported"));
  //   showErrMsg(toast, dispatch, "Number only supported", "AD", sectionList);
  // }
  if (hasError) {
    toast.error("Error Message", "Required field are missing");
  }
  return !hasError;
};

const personDetailValidation = (data, dispatch, toast, sectionList) => {
  dispatch(clearPersonalDetailError());
  let hasError = false;
  const {
    firstName,
    lastName,
    middleName,
    firstNameNep,
    lastNameNep,
    middleNameNep,
    dob,
    nationality,
    gender,
    pan,
    isNrn,
    nrnId,
    nrnAddress,
    citizenshipNo,
    issuedDistrict,
    issuedDate,
    isMinor,
  } = data.personalDetails;
  if (firstName === "" || firstName == null) {
    hasError = true;
    dispatch(
      setFirstNameError({ message: "First Name is required", section: "PD" })
    );
    showErrMsg(toast, dispatch, "First Name is required", "PD", sectionList);
  }

  if (lastName === "" || lastName == null) {
    hasError = true;
    dispatch(
      setLastNameError({ message: "Last Name is required", section: "PD" })
    );
    showErrMsg(toast, dispatch, "Last Name is required", "PD", sectionList);
  }

  if (firstNameNep === "" || firstNameNep == null) {
    hasError = true;
    dispatch(
      setFirstNameNepError({
        message: "First Name Nepali is required",
        section: "PD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "First Name Nepali is required",
      "PD",
      sectionList
    );
  }

  if (lastNameNep === "" || lastNameNep == null) {
    hasError = true;
    dispatch(
      setLastNameNepError({
        message: "Last Name Nepali is required",
        section: "PD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Last Name Nepali is required",
      "PD",
      sectionList
    );
  }
  checkAlphabetsAndDotsOnly(firstName + (middleName ? middleName + ' ' : '') + lastName, () => hasError = true, dispatch, setFirstNameError, "PD");
  checkNepaliAlphabetsAndDotsOnly(firstNameNep + (middleNameNep ? middleNameNep + ' ' : '') + lastNameNep, () => hasError = true, dispatch, setFirstNameNepError, "PD");

  if (dob === "" || dob == null) {
    hasError = true;
    dispatch(
      setDobError({
        message: "Date of Birth is required",
        section: "PD",
      })
    );
    showErrMsg(toast, dispatch, "Date of Birth is required", "PD", sectionList);
  }

  if (gender === "" || gender == null) {
    hasError = true;
    dispatch(
      setGenderError({
        message: "Gender is required",
        section: "PD",
      })
    );
    showErrMsg(toast, dispatch, "Gender is required", "PD", sectionList);
  }

  if (nationality === "" || nationality == null) {
    hasError = true;
    dispatch(
      setNationalityError({
        message: "Nationality is required",
        section: "PD",
      })
    );
    showErrMsg(toast, dispatch, "Nationality is required", "PD", sectionList);
  }

  if (pan && !numberCheck(pan)) {
    hasError = true;
    dispatch(
      setPanError({
        message: "Numbers only supported",
        section: "PD",
      })
    );
    showErrMsg(toast, dispatch, "Numbers only supported", "PD", sectionList);
  }

  if (hasError) {
    toast.error("Error Message", "Required field are missing");
  }
  return !hasError;
};

const personDetailValidationForSave = (data, dispatch, toast, sectionList) => {
  dispatch(clearPersonalDetailError());
  let hasError = false;
  const {
    firstName,
    lastName,
    middleName,
    firstNameNep,
    lastNameNep,
    middleNameNep,
    dob,
    nationality,
    gender,
    pan,
    isNrn,
    nrnId,
    nrnAddress,
    citizenshipNo,
    issuedDistrict,
    issuedDate,
    isMinor,
  } = data.personalDetails;
  if (firstName === "" || firstName == null) {
    hasError = true;
    dispatch(
      setFirstNameError({
        message: "First Name is required",
        section: "PD",
      })
    );
    showErrMsg(toast, dispatch, "First Name is required", "PD", sectionList);
  }

  if (lastName === "" || lastName == null) {
    hasError = true;
    dispatch(
      setLastNameError({
        message: "Last Name is required",
        section: "PD",
      })
    );
    showErrMsg(toast, dispatch, "Last Name is required", "PD", sectionList);
  }

  if (dob === "" || dob == null) {
    hasError = true;
    dispatch(
      setDobError({
        message: "Date of Birth is required",
        section: "PD",
      })
    );
    showErrMsg(toast, dispatch, "Date of Birth is required", "PD", sectionList);
  }

  if (gender === "" || gender == null) {
    hasError = true;
    dispatch(
      setGenderError({
        message: "Gender is required",
        section: "PD",
      })
    );
    showErrMsg(toast, dispatch, "Gender is required", "PD", sectionList);
  }

  if (nationality === "" || nationality == null) {
    hasError = true;
    dispatch(
      setNationalityError({
        message: "Nationality is required",
        section: "PD",
      })
    );
    showErrMsg(toast, dispatch, "Nationality is required", "PD", sectionList);
  }

  if (hasError) {
    toast.error("Error Message", "Required field are missing");
  }
  return !hasError;
};


const moneyLaunderingPreventionDetailValidation = (data, dispatch, toast, sectionList) => {
  dispatch(clearMoneyLaunderingDetailsError());
  let hasError = false;
  const moneyLaunderingDetails = data.moneyLaunderingDetails;
  if (moneyLaunderingDetails.highRankingOfficial === "" || moneyLaunderingDetails.highRankingOfficial == null) {
    hasError = true;
    dispatch(setMoneyLaunderingDetailsError({
      name: "highRankingOfficial",
      message: "High Ranking Official Type is required",
      section: "MLD",
    }));
    showErrMsg(
      toast,
      dispatch,
      "High Ranking Official Type is required",
      "MLD",
      sectionList
    );
  }

  if (moneyLaunderingDetails.relatedHighRankingOfficial != false) {
    if (moneyLaunderingDetails.relatedHighRankingOfficial === "" || moneyLaunderingDetails.relatedHighRankingOfficial == null) {
      hasError = true;
      dispatch(setRelatedHighRankingOfficialNameError({
        name: "relatedHighRankingOfficial",
        message: "Related Politician or High ranking official name and relation is required",
        section: "MLD",
      }));
      showErrMsg(toast,
        dispatch,
        "Related Politician or High ranking official name and relation is required",
        "MLD",
        sectionList
      );
    } else {
      if (moneyLaunderingDetails.relatedHighRankingOfficialName === "" || moneyLaunderingDetails.relatedHighRankingOfficialName == null) {
        hasError = true;
        dispatch(setRelatedHighRankingOfficialNameError({
          name: "relatedHighRankingOfficialName",
          message: "Related High Ranking Official Name is required",
          section: "MLD",
        }));
        showErrMsg(toast,
          dispatch,
          "Related High Ranking Official Name is required",
          "MLD",
          sectionList
        );
      }
      else {
        // Alphabet validation for relatedHighRankingOfficialName
        alphabetCheck(
          moneyLaunderingDetails.relatedHighRankingOfficialName,
          () => (hasError = true),
          dispatch,
          setRelatedHighRankingOfficialNameError,
          "MLD",
          "Related High Ranking Official Name should be in alphabet characters only"
        );
      }
      if (moneyLaunderingDetails.relatedHighRankingOfficialRelation === "" || moneyLaunderingDetails.relatedHighRankingOfficialRelation == null) {
        hasError = true;
        dispatch(setRelatedHighRankingOfficialRelationError({
          name: "relatedHighRankingOfficialRelation",
          message: "Related High Ranking Official Relation is required",
          section: "MLD",
        }));
        showErrMsg(toast,
          dispatch,
          "Related High Ranking Official Relation is required",
          "MLD",
          sectionList
        );
      }
    }
  }

  if (moneyLaunderingDetails.beneficiary != false) {
    if (moneyLaunderingDetails.beneficiary === "" || moneyLaunderingDetails.beneficiary == null) {
      hasError = true;
      dispatch(setBeneficiaryNameError({
        name: "beneficiary",
        message: "Beneficiary name and relation is required",
        section: "MLD",
      }));
      showErrMsg(toast,
        dispatch,
        "Beneficiary name and relation is required",
        "MLD",
        sectionList
      );
    } else {
      if (moneyLaunderingDetails.beneficiaryName === "" || moneyLaunderingDetails.beneficiaryName == null) {
        hasError = true;
        dispatch(setBeneficiaryNameError({
          name: "beneficiaryName",
          message: "Beneficiary Name is required",
          section: "MLD",
        }));
        showErrMsg(toast,
          dispatch,
          "Beneficiary Name is required",
          "MLD",
          sectionList
        );
      }
      else {
        // Alphabet validation for beneficiaryName
        alphabetCheck(
          moneyLaunderingDetails.beneficiaryName,
          () => (hasError = true),
          dispatch,
          setBeneficiaryNameError,
          "MLD",
          "Beneficiary Name should be in alphabet characters only"
        );
      }
      if (moneyLaunderingDetails.beneficiaryRelation === "" || moneyLaunderingDetails.beneficiaryRelation == null) {
        hasError = true;
        dispatch(setBeneficiaryRelationError({
          name: "beneficiaryRelation",
          message: "Beneficiary Relation is required",
          section: "MLD",
        }));
        showErrMsg(toast,
          dispatch,
          "Beneficiary Relation is required",
          "MLD",
          sectionList
        );
      }
    }
  }
  if (moneyLaunderingDetails.felonyState != false) {
    if (moneyLaunderingDetails.felonyState === "" || moneyLaunderingDetails.felonyState == null) {
      hasError = true;
      dispatch(setFelonyError({
        name: "felonyState",
        message: "Felony detail is required",
        section: "MLD",
      }));
      showErrMsg(toast,
        dispatch,
        "Felony detail is required",
        "MLD",
        sectionList
      );
    }
    else {
      if (moneyLaunderingDetails.felony === "" || moneyLaunderingDetails.felony == null) {
        hasError = true;
        dispatch(setFelonyError({
          name: "felony",
          message: "Felony detail is required",
          section: "MLD",
        }));
        showErrMsg(toast,
          dispatch,
          "Felony detail is required",
          "MLD",
          sectionList
        );
      }
      else {
        // Alphabet validation for felony
        alphabetCheck(
          moneyLaunderingDetails.felony,
          () => (hasError = true),
          dispatch,
          setFelonyError,
          // setMoneyLaunderingDetailsError,
          "MLD",
          "Felony detail should be in alphabet characters only"
        );
      }
    }
  }
  if (hasError) {
    toast.error("Error Message", "Required field are missing");
  }
  return !hasError;
};

const occupationDetailValidation = (data, dispatch, toast, sectionList) => {
  dispatch(clearOccupationDetailsError());
  let hasError = false;
  const occupationDetails = data.occupationDetails;
  // Validate occupationType is required
  // if (
  //   occupationDetails.occupationType === "" ||
  //   occupationDetails.occupationType == null
  // ) {
  //   hasError = true;
  //   dispatch(
  //     setOccupationTypeError({
  //       message: "Occupation Type is required",
  //       section: "OD",
  //     })
  //   );
  //   showErrMsg(
  //     toast,
  //     dispatch,
  //     "Occupation Type is required",
  //     "OD",
  //     sectionList
  //   );
  // }

  // if (
  //   occupationDetails.businessType === "" ||
  //   occupationDetails.businessType == null
  // ) {
  //   hasError = true;
  //   dispatch(setBusinessTypeError("Business Type is required"));
  // }

  // if (
  //   occupationDetails.organizationName === "" ||
  //   occupationDetails.organizationName == null
  // ) {
  //   hasError = true;
  //   dispatch(setOrganizationNameError("Organization Name is required"));
  // }

  // if (occupationDetails.address === "" || occupationDetails.address == null) {
  //   hasError = true;
  //   dispatch(setAddressError("Address is required"));
  // }

  // if (
  //   occupationDetails.designation === "" ||
  //   occupationDetails.designation == null
  // ) {
  //   hasError = true;
  //   dispatch(setDesignationError("Designation is required"));
  // }

  // if (occupationDetails.docId === "" || occupationDetails.docId == null) {
  //   hasError = true;
  //   dispatch(setDocIdError("Id Number is required"));
  // }
  if (occupationDetails.occupationType === "O") {
    if (
      occupationDetails.occupationTypeOthers === "" ||
      occupationDetails.occupationTypeOthers == null
    ) {
      hasError = true;
      dispatch(
        setOccupationTypeOthersError({
          message: "Occupation Type Others is required",
          section: "OD",
        })
      );
      showErrMsg(
        toast,
        dispatch,
        "Occupation Type Others is required",
        "OD",
        sectionList
      );
    } else {
      // Alphabet validation for occupationTypeOthers
      alphabetCheck(
        occupationDetails.occupationTypeOthers,
        () => (hasError = true),
        dispatch,
        setOccupationTypeOthersError,
        "OD",
        "Occupation type others should be in alphabet characters only"
      );
    }
  } else {
    // If "Others" is not selected, make sure some occupationType is selected
    if (
      occupationDetails.occupationType === "" ||
      occupationDetails.occupationType == null
    ) {
      hasError = true;
      dispatch(
        setOccupationTypeError({
          message: "Please select a valid Occupation Type",
          section: "OD",
        })
      );
      showErrMsg(
        toast,
        dispatch,
        "Please select a valid Occupation Type",
        "OD",
        sectionList
      );
    }
  }

  // Validate businessType is required
  // if (
  //   occupationDetails.businessType === "" ||
  //   occupationDetails.businessType == null
  // ) {
  //   hasError = true;
  //   dispatch(
  //     setBusinessTypeError({
  //       message: "Business Type is required",
  //       section: "OD",
  //     })
  //   );
  //   showErrMsg(
  //     toast,
  //     dispatch,
  //     "Business Type is required",
  //     "OD",
  //     sectionList
  //   );
  // }
  if (occupationDetails.businessType === "O") {
    // if (
    //   occupationDetails.businessTypeOthers === "" ||
    //   occupationDetails.businessTypeOthers == null
    // ) {
    //   hasError = true;
    //   dispatch(
    //     setBusinessTypeOthersError({
    //       message: "Business Type Others is required",
    //       section: "OD",
    //     })
    //   );
    //   showErrMsg(
    //     toast,
    //     dispatch,
    //     "Business Type Others is required",
    //     "OD",
    //     sectionList
    //   );
    // } else {
    //   // Alphabet validation for BusinessTypeOthers
    //   alphabetCheck(
    //     occupationDetails.businessTypeOthers,
    //     () => (hasError = true),
    //     dispatch,
    //     setBusinessTypeOthersError,
    //     "OD",
    //     "Business type others should be in alphabet characters only"
    //   );
    // }
    ////validation for alphabet check only working
    if (occupationDetails.businessTypeOthers) {
      alphabetCheck(
        occupationDetails.businessTypeOthers,
        () => (hasError = true),
        dispatch,
        setBusinessTypeOthersError,
        "OD",
        "Business type others should be in alphabet characters only"
      );
    }
  }
  //   else {
  //   // If "Others" is not selected, make sure some BusinessType is selected
  //   if (
  //     occupationDetails.businessType === "" ||
  //     occupationDetails.businessType == null
  //   ) {
  //     hasError = true;
  //     dispatch(
  //       setBusinessTypeError({
  //         message: "Please select a valid Business Type",
  //         section: "OD",
  //       })
  //     );
  //     showErrMsg(
  //       toast,
  //       dispatch,
  //       "Please select a valid Business Type",
  //       "OD",
  //       sectionList
  //     );
  //   }
  // }

  //oraganization name validation  for alphabet check only working
  if (occupationDetails.organizationName) {
    alphabetCheck(
      occupationDetails.organizationName,
      () => (hasError = true),
      dispatch,
      setOrganizationNameError,
      "OD",
      "Organization's name should be in alphabet characters only"
    );
  }

  // // Check if organizationName is empty
  // if (
  //   occupationDetails.organizationName === "" ||
  //   occupationDetails.organizationName == null
  // ) {
  //   hasError = true;
  //   dispatch(
  //     setOrganizationNameError({
  //       message: "Organization's name is required",
  //       section: "OD",
  //     })
  //   );
  //   showErrMsg(
  //     toast,
  //     dispatch,
  //     "Organization's name  is required",
  //     "OD",
  //     sectionList
  //   );
  // } else {
  //   // Alphabet validation for organizationName
  //   alphabetCheck(
  //     occupationDetails.organizationName,
  //     () => (hasError = true),
  //     dispatch,
  //     setOrganizationNameError,
  //     "OD",
  //     "Organization's name should be in alphabet characters only"
  //   );
  // }

  //address name validation  working
  if (occupationDetails.address) {
    alphabetCheck(
      occupationDetails.address,
      () => (hasError = true),
      dispatch,
      setAddressError,
      "OD",
      "Organization's Address should be in alphabet characters only"
    );
  }
  // // Check if address is empty
  // if (
  //   occupationDetails.address === "" ||
  //   occupationDetails.address == null
  // ) {
  //   hasError = true;
  //   dispatch(
  //     setAddressError({
  //       message: "Organization's Address is required",
  //       section: "OD",
  //     })
  //   );
  //   showErrMsg(
  //     toast,
  //     dispatch,
  //     "Organization's Address  is required",
  //     "OD",
  //     sectionList
  //   );
  // } else {
  //   // Alphabet validation for address
  //   alphabetCheck(
  //     occupationDetails.address,
  //     () => (hasError = true),
  //     dispatch,
  //     setAddressError,
  //     "OD",
  //     "Organization's Address should be in alphabet characters only"
  //   );
  // }

  //oraganization Designation validation 
  if (occupationDetails.designation) {
    alphabetCheck(
      occupationDetails.designation,
      () => (hasError = true),
      dispatch,
      setDesignationError,
      "OD",
      "Organization's designation should be in alphabet characters only"
    );
  }
  // //oraganization Designation validation 
  // if (
  //   occupationDetails.designation === "" ||
  //   occupationDetails.designation == null
  // ) {
  //   hasError = true;
  //   dispatch(
  //     setDesignationError({
  //       message: "Organization's designation is required",
  //       section: "OD",
  //     })
  //   );
  //   showErrMsg(
  //     toast,
  //     dispatch,
  //     "Organization's designation  is required",
  //     "OD",
  //     sectionList
  //   );
  // } else {
  //   // Alphabet validation for Organization's designation
  //   alphabetCheck(
  //     occupationDetails.designation,
  //     () => (hasError = true),
  //     dispatch,
  //     setDesignationError,
  //     "OD",
  //     "Organization's designation should be in alphabet characters only"
  //   );
  // }


  // Emplyoee ID validation  
  if (occupationDetails.docId) {
    checkAlphanumeric(
      occupationDetails.docId,
      () => (hasError = true),
      dispatch,
      setDocIdError,
      "OD",
      "Emplyoee ID should be in alpha-numeric characters only"
    );
  }
  // // Emplyoee ID validation  
  // if (
  //   occupationDetails.docId === "" ||
  //   occupationDetails.docId == null
  // ) {
  //   hasError = true;
  //   dispatch(
  //     setDocIdError({
  //       message: "Emplyoee ID is required",
  //       section: "OD",
  //     })
  //   );
  //   showErrMsg(
  //     toast,
  //     dispatch,
  //     "Emplyoee ID  is required",
  //     "OD",
  //     sectionList
  //   );
  // } else {
  //   // Alphabet validation for Emplyoee ID 
  //   alphabetCheck(
  //     occupationDetails.docId,
  //     () => (hasError = true),
  //     dispatch,
  //     setDocIdError,
  //     "OD",
  //     "Emplyoee ID should be in alpha-numeric characters only"
  //   );
  // }


  // Financial Details
  if (
    occupationDetails.financialDetails === "" ||
    occupationDetails.financialDetails == null
  ) {
    hasError = true;
    dispatch(
      setFinancialDetailsError({
        message: "Financial Details is required",
        section: "OD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Financial Details is required",
      "OD",
      sectionList
    );
  }

  //companyDetail of personal Details Client side 
  // Loop through companyRelationDetailsList to validate each entry
  if (occupationDetails.companyRelationDetailsList && occupationDetails.companyRelationDetailsList.length > 0) {
    occupationDetails.companyRelationDetailsList.forEach((companyDetail, index) => {
      // console.log(`checkkkkkk`, occupationDetails.companyRelationDetailsList);
      // Company Name and Relation validation
      if (companyDetail.companyNameOrRelation) {
        alphabetCheck(
          companyDetail.companyNameOrRelation,
          () => (hasError = true),
          dispatch,
          setCompanyNameOrRelationError,
          "OD",
          `Name and Relation at index ${index}  in table should be in alphabet characters only`
        );
      }
      //Company Name validation
      if (!companyDetail.companyNameRelation) {
        hasError = true;
        dispatch(
          setCompanyNameRelationError({
            message: `Company Name at index ${index} is required`,
            section: "OD",
          })
        );
        showErrMsg(
          toast,
          dispatch,
          `Company Name at index ${index} is required`,
          "OD",
          sectionList
        );
      } else {
        // Alphabet validation for Company Name
        alphabetCheck(
          companyDetail.companyNameRelation,
          () => (hasError = true),
          dispatch,
          setCompanyNameRelationError,
          "OD",
          `Company Name at index ${index} in table should be in alphabet characters only`
        );
      }
    });
  }
  if (hasError) {
    toast.error("Error Message", "Required field are missing");
  }
  return !hasError;
};

const occupationDetailValidationForSave = (
  data,
  dispatch,
  toast,
  sectionList
) => {
  dispatch(clearOccupationDetailsError());
  let hasError = false;
  const occupationDetails = data.occupationDetails;
  if (
    occupationDetails.occupationType === "" ||
    occupationDetails.occupationType == null
  ) {
    hasError = true;
    dispatch(
      setOccupationTypeError({
        message: "Occupation Type is required",
        section: "OD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Occupation Type is required",
      "OD",
      sectionList
    );
  }

  if (
    occupationDetails.businessType === "" ||
    occupationDetails.businessType == null
  ) {
    hasError = true;
    dispatch(
      setBusinessTypeError({
        message: "Business Type is required",
        section: "OD",
      })
    );
    showErrMsg(toast, dispatch, "Business Type is required", "OD", sectionList);
  }

  if (
    occupationDetails.organizationName === "" ||
    occupationDetails.organizationName == null
  ) {
    hasError = true;
    dispatch(
      setOrganizationNameError({
        message: "Organization Name is required",
        section: "OD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Organization Name is required",
      "OD",
      sectionList
    );
  }

  if (occupationDetails.address === "" || occupationDetails.address == null) {
    hasError = true;
    dispatch(
      setAddressError({
        message: "Address is required",
        section: "OD",
      })
    );
    showErrMsg(toast, dispatch, "Address is required", "OD", sectionList);
  }
  if (hasError) {
    toast.error("Error Message", "Required field are missing");
  }
  return !hasError;
};

const guardianDetailValidation = (data, dispatch, toast, sectionList) => {
  dispatch(clearGuardianDetailsError());
  let hasError = false;
  const guardianDetails = data.guardianDetails;
  if (data.personalDetails.isMinor) {
    if (guardianDetails.firstName === "" || guardianDetails.firstName == null) {
      hasError = true;
      dispatch(
        setGFirstNameError({
          message: "First Name is required",
          section: "GD",
        })
      );

      showErrMsg(toast, dispatch, "First Name is required", "GD", sectionList);
    }

    if (guardianDetails.lastName === "" || guardianDetails.lastName == null) {
      hasError = true;
      dispatch(
        setGLastNameError({
          message: "Last Name is required",
          section: "GD",
        })
      );
      showErrMsg(toast, dispatch, "Last Name is required", "GD", sectionList);
    }

    // if (
    //   guardianDetails.relationship === "" ||
    //   guardianDetails.relationship == null
    // ) {
    //   hasError = true;
    //   dispatch(
    //     setGRelationshipError({
    //       message: "Guardian Relation is required",
    //       section: "GD",
    //     })
    //   );
    //   showErrMsg(
    //     toast,
    //     dispatch,
    //     "Guardian Relation is required",
    //     "GD",
    //     sectionList
    //   );
    // }

    if (guardianDetails.country === "" || guardianDetails.country == null) {
      hasError = true;
      dispatch(
        setGCountryError({
          message: "Country is required",
          section: "GD",
        })
      );
      showErrMsg(toast, dispatch, "Country is required", "GD", sectionList);
    }
    if (guardianDetails.country === "NP") {
      if (guardianDetails.state === "" || guardianDetails.state == null) {
        hasError = true;
        dispatch(
          setGStateError({
            message: "State is required",
            section: "GD",
          })
        );
        showErrMsg(toast, dispatch, "State is required", "GD", sectionList);
      }

      if (guardianDetails.district === "" || guardianDetails.district == null) {
        hasError = true;
        dispatch(
          setGDistrictError({
            message: "District is required",
            section: "GD",
          })
        );
        showErrMsg(toast, dispatch, "District is required", "GD", sectionList);
      }

      if (
        guardianDetails.municipality === "" ||
        guardianDetails.municipality == null
      ) {
        hasError = true;
        dispatch(
          setGMunicipalityError({
            message: "Municipality is required",
            section: "GD",
          })
        );
        showErrMsg(
          toast,
          dispatch,
          "Municipality is required",
          "GD",
          sectionList
        );
      }

      if (guardianDetails.ward === "" || guardianDetails.ward == null) {
        hasError = true;
        dispatch(
          setGWardError({
            message: "Ward is required",
            section: "GD",
          })
        );
        showErrMsg(toast, dispatch, "Ward is required", "GD", sectionList);
      }
    }
    if (guardianDetails.tole === "" || guardianDetails.tole == null) {
      hasError = true;
      dispatch(
        setGToleError({
          message: "Tole is required",
          section: "GD",
        })
      );

      showErrMsg(toast, dispatch, "Tole is required", "GD", sectionList);
    }
    if (guardianDetails.emailId === "" || guardianDetails.emailId == null) {
      hasError = true;
      dispatch(
        setGEmailIdError({
          message: "Email Id is required",
          section: "GD",
        })
      );
      showErrMsg(toast, dispatch, "Email Id is required", "GD", sectionList);
    }
    if (guardianDetails.mobileNo === "" || guardianDetails.mobileNo == null) {
      hasError = true;
      dispatch(
        setGMobileNoError({
          message: "Mobile Number is required",
          section: "GD",
        })
      );
      showErrMsg(
        toast,
        dispatch,
        "Mobile Number is required",
        "GD",
        sectionList
      );
    }

    // if (
    //   guardianDetails.telephoneNo &&
    //   !numberCheck(guardianDetails.telephoneNo)
    // ) {
    //   hasError = true;
    //   dispatch(setGTelephoneNoError("Number only supported"));
    //   showErrMsg(toast, dispatch, "Number only supported", "GD", sectionList);
    // }

    if (
      guardianDetails.mobileNo &&
      !numberCheck(guardianDetails.mobileNo) &&
      guardianDetails.mobileNo.length !== 10
    ) {
      hasError = true;
      dispatch(
        setGMobileNoError({
          message: "10 digit numbers only supported",
          section: "GD",
        })
      );
      showErrMsg(toast, dispatch, "Number only supported", "GD", sectionList);
    }
    if (guardianDetails.emailId && !emailCheck(guardianDetails.emailId)) {
      hasError = true;
      dispatch(
        setGEmailIdError({
          message: "Provide Valid Email",
          section: "GD",
        })
      );
      showErrMsg(toast, dispatch, "Provide Valid Email", "GD", sectionList);
    }

    if (guardianDetails.fax && !numberCheck(guardianDetails.fax)) {
      hasError = true;
      dispatch(
        setGFaxError({
          message: "Number only supported",
          section: "GD",
        })
      );
      showErrMsg(toast, dispatch, "Number only supported", "GD", sectionList);
    }
    if (guardianDetails.guardianDocumentList.length !== 0) {
      const dType = guardianDetails.guardianDocumentList.find(p => p.documentTypeId == "GCZ");
      console.log("ins")
      if (!dType.docId || dType.docId === null || dType.docId == "") {
        hasError = true;
        dispatch(
          setGDocIdError({
            message: "Document Id is required",
            section: "GD",
          })
        );
        showErrMsg(toast, dispatch, "Document Id is required", "GD", sectionList);
      }

      if (!dType.issuedDate || dType.issuedDate === null || dType.issuedDate == "") {
        hasError = true;
        dispatch(
          setGIssuedDateError({
            message: "Issued Date is required",
            section: "GD",
          })
        );
        showErrMsg(toast, dispatch, "Issued Date is required", "GD", sectionList);
      }

      if (!dType.issuedDateBs || dType.issuedDateBs === null || dType.issuedDateBs == "") {
        hasError = true;
        dispatch(
          setGIssuedDateBsError({
            message: "Issued Date(BS) is required",
            section: "GD",
          })
        );
        showErrMsg(toast, dispatch, "Issued Date(BS) is required", "GD", sectionList);
      }

      if (!dType.issuedFrom || dType.issuedFrom === null || dType.issuedFrom == "") {
        hasError = true;
        dispatch(
          setGIssuedFromError({
            message: "Issuing Place is required",
            section: "GD",
          })
        );
        showErrMsg(toast, dispatch, "Issuing Place is required", "GD", sectionList);
      }

      if (!dType.fileId || dType.fileId === null || dType.fileId == "") {
        hasError = true;
        dispatch(
          setGFileIdError({
            message: "Image is required",
            section: "GD",
          })
        );
        showErrMsg(toast, dispatch, "Image is required", "GD", sectionList);
      }

      if (!dType.backFileId || dType.backFileId === null || dType.backFileId == "") {
        hasError = true;
        dispatch(
          setGBackFileIdError({
            message: "Image is required",
            section: "GD",
          })
        );
        showErrMsg(toast, dispatch, "Image is required", "GD", sectionList);
      }
    }
  }
  if (hasError) {
    toast.error("Error Message", "Required field are missing");
  }
  return !hasError;
};

const guardianDetailValidationForSave = (
  data,
  dispatch,
  toast,
  sectionList
) => {
  dispatch(clearGuardianDetailsError());
  let hasError = false;
  const guardianDetails = data.guardianDetails;
  if (guardianDetails.firstName === "" || guardianDetails.firstName == null) {
    hasError = true;
    dispatch(
      setGFirstNameError({
        message: "First Name is required",
        section: "GD",
      })
    );
    showErrMsg(toast, dispatch, "First Name is required", "GD", sectionList);
  }

  if (guardianDetails.lastName === "" || guardianDetails.lastName == null) {
    hasError = true;
    dispatch(
      setGLastNameError({
        message: "Last Name is required",
        section: "GD",
      })
    );
    showErrMsg(toast, dispatch, "Last Name is required", "GD", sectionList);
  }

  if (
    guardianDetails.relationship === "" ||
    guardianDetails.relationship == null
  ) {
    hasError = true;
    dispatch(
      setGRelationshipError({
        message: "Guardian Relation is required",
        section: "GD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Guardian Relation is required",
      "GD",
      sectionList
    );
  }

  if (guardianDetails.emailId === "" || guardianDetails.emailId == null) {
    hasError = true;
    dispatch(
      setGEmailIdError({
        message: "Email Id is required",
        section: "GD",
      })
    );
    showErrMsg(toast, dispatch, "Emai Id is required", "GD", sectionList);
  }
  if (guardianDetails.mobileNo === "" || guardianDetails.mobileNo == null) {
    console.log("guardianDetails.mobileNo :", guardianDetails.mobileNo);
    hasError = true;
    dispatch(
      setGMobileNoError({
        message: "Mobile Number is required",
        section: "GD",
      })
    );
    showErrMsg(toast, dispatch, "Mobile Number is required", "GD", sectionList);
  } else if (
    guardianDetails.mobileNo &&
    !numberCheck(guardianDetails.mobileNo) &&
    guardianDetails.mobileNo.length !== 10
  ) {
    hasError = true;
    dispatch(
      setGMobileNoError({
        message: "10 digit numbers only supported",
        section: "GD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "10 digit numbers only supported",
      "GD",
      sectionList
    );
  } else if (
    guardianDetails.country === "NP" &&
    guardianDetails.mobileNo.length !== 13
  ) {
    console.log(
      "mobile",
      guardianDetails.mobileNo,
      guardianDetails.mobileNo.length
    );
    hasError = true;
    dispatch(
      setGMobileNoError({
        message: "Mobile number must contain 10 digits",
        section: "GD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Mobile number must contain 10 digits",
      "GD",
      sectionList
    );
  } else if (guardianDetails.mobileNo.length < 5) {
    hasError = true;
    dispatch(
      setGMobileNoError({
        message: "Mobile Number length must be greater than 5 digits",
        section: "GD",
      })
    );
    showErrMsg(
      toast,
      dispatch,
      "Mobile Number length must be greater than 5 digits",
      "GD",
      sectionList
    );
  }
  if (guardianDetails.emailId && !emailCheck(guardianDetails.emailId)) {
    hasError = true;
    dispatch(
      setGEmailIdError({
        message: "Provide Valid Email",
        section: "GD",
      })
    );
    showErrMsg(toast, dispatch, "Provide Valid Email", "GD", sectionList);
  }
  if (hasError) {
    toast.error("Error Message", "Required field are missing");
  }

  return !hasError;
};

const familyNameMapCd = {
  GF: "Grand Father",
  F: "Father",
  M: "Mother",
};

// const familyDetailValidation = (data, dispatch, toast, sectionList) => {
//   const relativeList = data.familyDetails.relativeList;
//   const relativeTypeMap = data.familyDetails.relativeTypeList.reduce((a, v) => {
//     if (v.relativeType) a[v.relativeType.code] = v.relativeType.descEng;

//     return a;
//   }, {});

//   const mandatoryFamilyCd = Object.keys(familyNameMapCd);
//   const cFamilyIdList = relativeList
//     .filter(
//       (p) =>
//         mandatoryFamilyCd.includes(p.relativeTypeId) &&
//         p.firstName &&
//         p.lastName && p.firstNameNep && p.lastNameNep
//     )
//     .map((p) => p.relativeTypeId);

//   mandatoryFamilyCd
//     .filter((fCode) => !cFamilyIdList.includes(fCode))
//     .forEach((fCode) => {
//       dispatch(
//         setFamilyDetailsError({
//           key: fCode + "FamilyError",
//           message:
//             (relativeTypeMap[fCode] || familyNameMapCd[fCode]) +
//             "'s name both english and nepali is mandatory",
//           section: "FD",
//         })
//       );
//     });

//   return cFamilyIdList.length >= 3;
// };

const familyDetailValidation = (data, dispatch, toast, sectionList) => {
  const relativeList = data.familyDetails.relativeList;
  const relativeTypeMap = data.familyDetails.relativeTypeList.reduce((a, v) => {
    if (v.relativeType) a[v.relativeType.code] = v.relativeType.descEng;

    return a;
  }, {});

  const mandatoryFamilyCd = Object.keys(familyNameMapCd);
  let cFamilyIdList = relativeList
    .filter(
      (p) =>
        mandatoryFamilyCd.includes(p.relativeTypeId) &&
        p.firstName &&
        p.lastName
      // && p.firstNameNep && p.lastNameNep
    )
    .map((p) => p.relativeTypeId);
  mandatoryFamilyCd
    .filter((fCode) => !cFamilyIdList.includes(fCode))
    .forEach((fCode) => {
      dispatch(
        setFamilyDetailsError({
          key: fCode + "FamilyError",
          message:
            (relativeTypeMap[fCode] || familyNameMapCd[fCode]) +
            "'s name both english and nepali is mandatory",
          section: "FD",
        })
      );
    });
  relativeList.forEach((f) => {
    if (f.firstName && f.lastName)
      checkAlphabetsAndDotsOnly(f.firstName + (f.middleName ? f.middleName + ' ' : '') + f.lastName, () => cFamilyIdList = [], dispatch, setFamilyDetailsError, "FD", f.relativeTypeId);
    // if(f.firstNameNep && f.lastNameNep)
    //   checkNepaliAlphabetsAndDotsOnly(f.firstNameNep+(f.middleNameNep ? f.middleNameNep + ' ' : '')+f.lastNameNep,() => cFamilyIdList=[],dispatch,setFamilyDetailsError,"FD",f.relativeTypeId);

  })
  return cFamilyIdList.length >= 3;
};

const validateFamilyForMandatoryField = (
  data,
  dispatch,
  toast,
  sectionList
) => {
  const maritalStatus = data.personalDetails.maritalStatus;
  const relativeList = data.familyDetails.relativeList;
  const isMandatoryObj = data.familyDetails.relativeTypeList.filter(
    (p) => p.isMandatory == true
  );
  const filteredList = relativeList.filter((o1) =>
    isMandatoryObj.some((o2) => o1.relativeTypeId === o2.code)
  );

  return !filteredList
    .filter(p => p?.relativeType?.maritalStatus == null ||
      (p?.relativeType?.maritalStatus === maritalStatus))
    .map((p) => {
      console.log(p);
      if (!p.firstName || !p.lastName) {
        dispatch(
          setFamilyDetailsError({
            key: p.relativeType.code + "FamilyError",
            message: p.relativeType.descEng + "'s name is mandatory",
            section: "FD",
          })
        );
        return false;
      }

      return true;
    }).filter(p => !p).length;
};

const dynamicParameterValidation = (data, dispatch, toast) => {
  const dynamicDatas = data.dynamicFieldDetails.allDynamicField;
  const sectionList = data.routerData.sectionList;

  const missingList = Object.keys(dynamicDatas)
    .filter((k) => {
      console.log('(dynamicDatas[k]', dynamicDatas[k]);
      if (sectionList.find((sc) => sc.id == dynamicDatas[k].sectionId)) {
        if (dynamicDatas[k].mandatory === true &&
          !dynamicDatas[k].value) {
          dispatch(
            setDynamicSelectedError({
              dynamicKey: k,
              errorDesc: "Field is Required",
            })
          );
          return true;
        } else if (dynamicDatas[k].regex && dynamicDatas[k].value && !new RegExp(dynamicDatas[k].regex).test(dynamicDatas[k].value)) {
          dispatch(
            setDynamicSelectedError({
              dynamicKey: k,
              errorDesc: "Invalid Format",
            })
          );
          return true;
        }
      }
      dispatch(
        setDynamicSelectedError({
          dynamicKey: k,
          errorDesc: null,
        })
      );
      return false;
    });

  return !(missingList.length);
};

const checkCompanyDocument = (d, data, dispatch, toast, sectionList) => {
  let hasError = true;
  var message,
    section = "DOD";

  switch (d.documentTypeId) {
    //  case "RG":
    case "TC":
      hasError = !d.fileId || !d.docId;
      message =
        " File and document id of " +
        d.documentTypeDesc +
        " document are required";
      break;
    case "MP":
      section = "AD";
      hasError = !d.fileId;
      message = "Map Image is required";
      break;
    // case "PH":
    //   section = "PD";
    //   hasError = !d.fileId;
    //   message = "Photo is required";
    //   break;
    default:
      hasError = false;
      message = "";
  }

  if (d.empty && d.isMandatory) {
    hasError = true;
    message = d.documentTypeDesc + " is Mandatory";
  }

  if (hasError)
    dispatch(
      setDocumentError({
        key: d.documentTypeId + "DocumentError",
        section,
        message,
      })
    );

  return hasError;
};

// const checkPersonDocument = (d, data, dispatch, toast, param) => {
//   let hasError = true;
//   var message,
//     section = "DOD";

//   switch (d.documentTypeId) {
//     case "CZ":
//       hasError = !d.fileId || !d.docId || !d.issuedFrom || !d.issuedDate;
//       message =
//         " Document id, Issued Date, Issuing Authority/Place and File of " +
//         d.documentTypeDesc +
//         " document are required";
//       break;
//     case "BC":
//       hasError = !d.fileId || !d.docId || !d.issuedFrom || !d.issuedDate;
//       message =
//         // " Document id and File of " +
//         " Document id, Issued Date, Issuing Authority/Place and File of " +
//         d.documentTypeDesc +
//         " document are required";
//       break;
//     case "NR":
//       hasError = !d.fileId || !d.docId;
//       message =
//         " Document id and File of " +
//         d.documentTypeDesc +
//         " document are required";
//       break;
//     case "PP":
//       hasError = !d.fileId || !d.docId || !d.issuedDate;
//       message =
//         " Document id, Expiry Date and File of " +
//         d.documentTypeDesc +
//         " document are required";
//       break;
//     case "MP":
//       section = "AD";
//       hasError = !d.fileId;
//       message = "Map Image is required";
//       break;
//     case "PH":
//       section = "PD";
//       hasError = !d.fileId;
//       message = "Photo is required";
//       break;
//     default:
//       hasError = false;
//       message = "";
//   }

//   if (d.empty && d.isMandatory) {
//     hasError = true;
//     message = d.documentTypeDesc + " is Mandatory";
//   }

//   if (hasError)
//     dispatch(
//       setDocumentError({
//         key: d.documentTypeId + "DocumentError",
//         section,
//         message,
//       })
//     );

//   return hasError;
// };

// new kept from admin on 6-12-2025
const checkPersonDocument = (d, data, dispatch, toast, param) => {

  const { nationality, isMinor, isNrn, documentForMinor, locationType, checkNrn, checkCz } = param;
  let hasError = true;
  var message,
    section = "DOD";

  switch (d.documentTypeId) {
    case "CZ":
      if (checkCz) {
        hasError = !d.fileId || !d.docId || !d.issuedFrom || !d.issuedDate;
        //  || !alphanumericCheck(d.docId);
        // message =
        //   " Document ID must match (alphanumeric), Issued Date, Issuing Authority/Place and File of " +
        message =
          " Document ID must match, Issued Date, Issuing Authority/Place and File of " +
          d.documentTypeDesc +
          " document are required";
      } else {
        hasError = false;
        message = "";
      }
      break;
    case "BC":
      hasError = !d.fileId || !d.docId;
      // || !alphanumericCheck(d.docId);
      // message =
      //   " Document ID must match (alphanumeric) and File of " +
      message =
        " Document ID must match and File of " +
        d.documentTypeDesc +
        " document are required";
      break;
    case "NR":
      if (checkNrn) {
        hasError = !d.fileId || !d.docId || !alphanumericCheck(d.docId);
        message =
          " Document ID must match (alphanumeric) and File of " +
          d.documentTypeDesc +
          " document are required";
      } else {
        hasError = false;
        message = "";
      }
      break;
    case "PP":
      hasError = !d.fileId || !d.docId || !d.issuedDate || !alphanumericCheck(d.docId);
      message =
        " Document ID must match (alphanumeric), Expiry Date and File of " +
        d.documentTypeDesc +
        " document are required";
      break;
    case "MP":
      section = "AD";
      hasError = !d.fileId;
      message = "Map Image is required";
      break;
    case "PH":
      section = "PD";
      hasError = !d.fileId;
      message = "Photo is required";
      break;
    default:
      hasError = false;
      message = "";
  }

  if (d.empty && d.isMandatory) {
    hasError = true;
    message = d.documentTypeDesc + " is Mandatory.";
  }
  if ((d.documentTypeId == 'CZ' && !checkCz)) {
    hasError = false;
    message = "";
  }

  if ((d.documentTypeId == 'NR' && !checkNrn)) {
    hasError = false;
    message = "";
  }
  if (hasError)
    dispatch(
      setDocumentError({
        key: d.documentTypeId + "DocumentError",
        section,
        message,
      })
    );

  return hasError;
};

const documentValidation = (data, dispatch, toast, sectionList) => {
  const documentList = data.documentDetails.documentList;
  const documentTypeList = data.documentDetails.documentTypeList;
  const { nationality, isMinor, isNrn, documentForMinor } =
    data.personalDetails || {};
  const locationType = data.addressDetails.locationType;

  let missingDocumentList = [];
  if (data.routerData.formType === "I") {
    let checkNrn = true;
    let checkCz = true;
    if (isNrn) {
      if (documentList.filter((m) => m.code == "NR" || m.code == "CZ").length < 1) {
        dispatch(
          setDocumentError({
            key: (documentTypeList.find(d => d.code == "NR") || {}).documentTypeId + "DocumentError",
            section: "DOD",
            message: "NRN Document or citizenship is required.",
          })
        );
      }
      checkNrn = documentList.find((m) => m.code == "NR") !== undefined;
      checkCz = documentList.find((m) => m.code == "CZ") !== undefined;
    }
    missingDocumentList = documentTypeList
      .filter((d) =>
        filterDocument(d, {
          nationality,
          isMinor,
          isNrn,
          documentForMinor,
          locationType,
          checkNrn,
          checkCz
        })
      )
      .map(
        (d) =>
          documentList.find((dd) => dd.documentTypeId === d.code) || {
            ...d,
            empty: true,
            documentTypeId: d.code,
            documentTypeDesc: d.descEng,
            documentTypeDescNp: d.descNep,
            type: d.type,
            isBothSided: d.isBothSided,
          }
      )
      .filter((d) =>
        checkPersonDocument(d, data, dispatch, toast, {
          nationality,
          isMinor,
          isNrn,
          documentForMinor,
          locationType,
          checkNrn, checkCz
        })
      );
  } else {
    missingDocumentList = documentTypeList
      .filter((d) => filterCompanyDocument(d, { locationType }))
      .map(
        (d) =>
          documentList.find((dd) => dd.documentTypeId === d.code) || {
            ...d,
            empty: true,
            documentTypeId: d.code,
            documentTypeDesc: d.descEng,
            documentTypeDescNp: d.descNep,
            type: d.type,
            isBothSided: d.isBothSided,
          }
      )
      .filter((d) =>
        checkCompanyDocument(d, data, dispatch, toast, { locationType })
      );
  }

  return !missingDocumentList.length;
};

const mandatoryDocumentValidation = (data, dispatch, toast) => {
  const documentList = data.documentDetails.documentList;
  const isMandatoryObj = data.documentDetails.documentTypeList.filter(
    (p) => p.isMandatory == true && p.type === "I"
  );
  const mandaatoryFieldDesc = isMandatoryObj.map((p) => p.descEng);
  console.log(isMandatoryObj, "is");
  const filteredList = documentList.filter((o1) =>
    isMandatoryObj.some((o2) => o1.documentTypeId === o2.code)
  );
  console.log(filteredList, "filteredList");
  if (filteredList.length == 0) {
    dispatch(
      setDocumentError({
        key: mandaatoryFieldDesc[0] + "DocumentError",
        section: "DD",
        message: mandaatoryFieldDesc + " is required",
      })
    );
  }

  filteredList.forEach((p) => {
    if (!p.fileId && !p.docId) {
      dispatch(
        setDocumentError({
          key: p.documentTypeId + "DocumentError",
          section: "DD",
          message: p.documentTypeDesc + " is required",
        })
      );
    }
  });
};

export const declerationValidation = (data, dispatch, toast) => {
  const { dChecked, dName, formType } = data.routerData;
  const name =
    formType === "I"
      ? data.personalDetails.firstName +
      " " +
      (data.personalDetails.middleName
        ? data.personalDetails.middleName + " "
        : "") +
      data.personalDetails.lastName
      : data.companyDetails.companyName;
  if (!dChecked) {
    return false;
  } else if (dName !== name) {
    return false;
  }

  return true;
};

export const validateSubmitData = (
  data,
  dispatch,
  toast,
  history,
  sectionList
) => {
  redirectList = [];
  dispatch(setErrorList([]));

  if (data.routerData.formType === "I") {
    const pFlag = personDetailValidation(data, dispatch, toast, sectionList);
    const aFlag = personAddressValidation(data, dispatch, toast, sectionList);
    const bkFlag = bankValidation(data, dispatch, toast, sectionList);
    // bankValidation(data, dispatch, toast) &&
    const bFlag = boidValidation(data, dispatch, toast, sectionList);
    const gFlag = guardianDetailValidation(data, dispatch, toast, sectionList);
    const oFlag = occupationDetailValidation(
      data,
      dispatch,
      toast,
      sectionList
    );
    const mFlag = moneyLaunderingPreventionDetailValidation(
      data,
      dispatch,
      toast,
      sectionList
    );
    const dFlag = documentValidation(data, dispatch, toast, sectionList);
    const fFlag = familyDetailValidation(data, dispatch, toast, sectionList);
    const dyFlag = dynamicParameterValidation(data, dispatch, toast);
    const manFamilyFlag = validateFamilyForMandatoryField(
      data,
      dispatch,
      toast
    );
    return (
      pFlag &&
      aFlag &&
      bkFlag &&
      bFlag &&
      gFlag &&
      oFlag &&
      mFlag &&
      dFlag &&
      fFlag &&
      dyFlag &&
      manFamilyFlag
    );
  }

  if (data.routerData.formType === "C") {
    const cFlag = companyDetailsValidation(data, dispatch, toast, sectionList);
    const aFlag = companyAddressValidation(data, dispatch, toast, sectionList);
    const dirFlag = companyDirectorValidation(
      data,
      dispatch,
      toast,
      sectionList
    );
    // bankValidation(data, dispatch, toast) &&
    const bFlag = boidValidation(data, dispatch, toast, sectionList);
    const dFlag = documentValidation(data, dispatch, toast, sectionList);
    const dyFlag = dynamicParameterValidation(data, dispatch, toast);
    return cFlag && aFlag && dirFlag && bFlag && dFlag && dyFlag;
  }

  // const flag =
  //   (data.routerData.formType === "I" &&
  //     personDetailValidation(data, dispatch, toast, sectionList)) ||
  //   personAddressValidation(data, dispatch, toast, sectionList) ||
  //   // bankValidation(data, dispatch, toast) &&
  //   boidValidation(data, dispatch, toast, sectionList) ||
  //   guardianDetailValidation(data, dispatch, toast, sectionList) ||
  //   occupationDetailValidation(data, dispatch, toast, sectionList) ||
  //   documentValidation(data, dispatch, toast, sectionList) ||
  //   familyDetailValidation(data, dispatch, toast, sectionList) ||
  //   (data.routerData.formType === "C" &&
  //     companyDetailsValidation(data, dispatch, toast, sectionList)) ||
  //   companyAddressValidation(data, dispatch, toast, sectionList) ||
  //   companyDirectorValidation(data, dispatch, toast, sectionList) ||
  //   // bankValidation(data, dispatch, toast) &&
  //   boidValidation(data, dispatch, toast, sectionList) ||
  //   documentValidation(data, dispatch, toast, sectionList) ||
  //   dynamicParameterValidation(data, dispatch, toast);

  //dispatch(setErrorList(redirectList));

  // return flag;
};

export const validateSaveData = (
  data,
  dispatch,
  toast,
  history,
  sectionList
) => {
  redirectList = [];
  dispatch(setErrorList([]));
  const flag =
    (data.routerData.formType === "C" &&
      companyDetailsValidationForSave(data, dispatch, toast, sectionList)) ||
    // && companyAddressValidation(data, dispatch, toast)
    // && companyDirectorValidationForSave(data, dispatch, toast)
    // && bankValidation(data, dispatch, toast)
    // && documentValidation(data, dispatch, toast)
    // && boidValidation(data, dispatch, toast)
    (data.routerData.formType === "I" &&
      personDetailValidationForSave(data, dispatch, toast, sectionList) &&
      personAddressValidationForSave(data, dispatch, toast, sectionList));
  //  mandatoryDocumentValidation(data, dispatch, toast, sectionList));
  dispatch(setErrorList(redirectList));

  return flag;
};
